import { type ErrorContexts, type WithContext } from './WithContext';

interface AbortErrorOptions {
    message?: string;
    context?: ErrorContexts;
    cause?: unknown;
}

export class AbortError extends Error implements WithContext {
    public readonly context?: ErrorContexts;

    constructor(options?: AbortErrorOptions) {
        const { message, context, cause } = options || {};
        // FIXME: Upgrade compilerOptions.lib to ES2022 to use `cause` in Error constructor
        // https://github.com/lingoda/lingoda/pull/26251
        // @ts-expect-error - TypeScript does not support passing cause in Error yet
        super(message || 'AbortError', { cause });
        this.name = 'AbortError';
        this.context = context;
    }
}
